<template>
    <modal @close="$emit('close'); $emit('reload')">
        <template slot="header">
            Upload list (TXT/CSV file, one address per line) -
            <template v-if="form._id">edit</template>
            <template v-if="!form._id">add new</template>
        </template>
        <div class="alert alert-danger">Input fields and then select CSV file to upload list. The upload will start immediately after you select a file.</div>
        <fieldset class="mb-3" :class="{'loading-mask': loading}">
            <div class="form-group row">
                <label class="col-form-label col-lg-2">Count per list</label>
                <div class="col-lg-4">
                    <input type="number" class="form-control" v-model="max_count"/>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2">List name prefix</label>
                <div class="col-lg-4">
                    <input type="text" class="form-control" v-model="name_prefix"/>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2"></label>
                <div class="col-lg-4">
                    <upload :disabled="name_prefix == '' || max_count == 0" :onUploadCompleted="completed" :onUploadProgress="inprogress" :url="url" :multiple="false" :accept="''" />
                </div>
            </div>
            <div class="alert alert-danger" v-if="err">{{err}}</div>
            <div class="alert alert-success" v-if="success">{{success}}</div>
            <div class="form-group row">
                <label class="col-form-label col-lg-12">
                    <button class="btn btn-link" @click="$emit('close')">Close</button>
                </label>
            </div>
        </fieldset>
    </modal>
</template>
<script>
import modal from '../common/Modal.vue'
import upload from '../common/FileUpload.vue'

export default {
    components: { modal, upload },
    props: {
        id: null,
    },
    data() {
        return {
            form: {
                title: null,
            },
            err: null,
            max_count: 0,
            name_prefix: '',
            loading: false,
            success: null
        }
    },
    computed: {
        url: function() {
            return `upload_contact_list_creator?max_list_count=${this.max_count}&list_name_prefix=${this.name_prefix}`
        },
    },
    methods: {
        completed(res, body) {
            if (body.data) {
                var d = body.data
                this.success = `
                Success
                `
            }
        },
        inprogress(res, body) {},
    },
    mounted() {

        if (typeof this.id !== 'string') {
            return
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modal/UploadContacts.vue